import { jsx as _jsx } from "react/jsx-runtime";
import { FormControl as BaseFormControl, forwardRef, } from '@chakra-ui/react';
import { CLASS_NAMES } from '../constants';
export { FormWarningMessage } from './FormWarningMessage';
export const FormControl = forwardRef(({ isWarning = false, ...otherProps }, ref) => {
    return (_jsx(BaseFormControl, { ref: ref, ...otherProps, sx: {
            ...(otherProps.isDisabled && {
                [`.${CLASS_NAMES.FORM__HELPER_TEXT}, .${CLASS_NAMES.FORM__LABEL}`]: {
                    opacity: 0.5,
                },
            }),
            ...otherProps.sx,
        } }));
});
